<template>
  <div class="real-auth-result" :class="{ check: isCheckApp, hunter: isHunterApp }">
    <section v-if="!intermediate">
      <img v-if="result === 'true'" :src="$setPicSize(successImg)" />
      <img v-if="result === 'false'" :src="$setPicSize(failImg)" />
      <div class="result-info">
        <header v-if="result === 'true'">恭喜您认证成功</header>
        <header v-if="result === 'false'">很遗憾认证失败</header>
        <div class="desc">{{ resInfo }}</div>
      </div>
      <div class="operation-area">
        <div v-for="ctx in adapterButtonCtxes(buttonCtxes)" :key="ctx.type" :class="ctx.style" @click="doCommand(ctx)">
          <span>{{ ctx.text }}</span>
        </div>
      </div>
    </section>
   <section v-if="intermediate">
      <img :src="$setPicSize(intermediateInfo.picUrl)" />
      <div class="result-info">
        <header>{{intermediateInfo.title}}</header>
        <div class="desc">{{ intermediateInfo.content }}</div>
      </div>
      <div class="operation-area">
        <div v-for="ctx in adapterButtonCtxes(intermediateInfo.retButtons)" :key="ctx.type" :class="ctx.style" @click="doCommand(ctx)">
          <span>{{ ctx.text }}</span>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import native from '@zz-common/native-adapter'
import setPicSize from '@zz-app/setPicSize'
import { lego } from '@zz-common/lego'
import { getsdkcallbacktext } from '@api/resourceApi'
import { toast } from '../../native'
import { queryParams, getCookie, isCheckApp, isHunterApp, adapterSchema, compareVersion } from '../../lib/utils'

const query = queryParams()
const zzv = query.zzv || getCookie('v')
const vers = zzv && zzv.split('.')
let lower54 = false
if (vers && ((vers[0] === 5 && vers[1] < 4) || vers[0] < 5) && !isCheckApp && !isHunterApp) {
  lower54 = true
}

export default {
  name: 'ResultComp',
  data() {
    return {
      from: query.from || this.$route.query.from,
      strategyid: query.strategyid || this.$route.query.strategyid,
      txCode: query.code || this.$route.query.code,
      // orderNo: query.orderNo || this.$route.query.orderNo,
      // h5faceId: query.h5faceId || this.$route.query.h5faceId,
      // signature: query.signature || this.$route.query.signature,
      agreementNo: query.agreementNo || this.$route.query.agreementNo,
      authtype: query.authtype || this.$route.query.authtype || '', //  认证类型challenge代表二次挑战认证
      isInter: query.intermediate || this.$route.intermediate || '', //是否是拦截状态
      result: '',
      resInfo: '',
      buttonCtxes: [],
      isCheckApp,
      isHunterApp,
      successImg: 'f9436be4-ddfb-4f7b-8047-f0ae914e714c.png',
      failImg: '2980c180-8a0e-48e5-9ffb-ec7ad3ec4766.png',
      intermediate: '' //其他业务结果拦截 json字符串
    }
  },
  computed: {
    isFromMe() {
      return this.from === 'selfmain_page' || this.from === 'my_page'
    },
    isTimesExceeded() {
      return this.txCode === '66660017'
    },
    isIDCardFailed() {
      return this.txCode === '-4017' || this.txCode === '66660005'
    },
    intermediateInfo() {
      let res = {}
      try {
        res = JSON.parse(this.intermediate)
      } catch (err) {
        console.log(err)
      }
      return res
    }
  },
  methods: {
    /**
     * 判断当前app版本是否低于11.16.0
     * 用于二次放号场景客户端needclose冲突的处理
     * @returns {boolean} 如果版本低于11.16.0返回true，否则返回false
     */
    isVersionLowerThan11_16_0() {
      if (!zzv) return false
      // 使用项目现有的compareVersion方法：如果当前版本小于11.16.0，返回false（表示版本过低）
      return !compareVersion(zzv, '11.16.0')
    },
    $setPicSize(url) {
      return setPicSize(url, 500, 500)
    },
    adapterOS() {
      if (isCheckApp) {
        this.successImg = 'n_v240eae3d853a749dea0235916fb469918.png'
        this.failImg = 'n_v23dcff40005ca49e5ac688d6b03c99549.png'
      }
      if (isHunterApp) {
        this.successImg = '1b92b94c-6cfe-4eb3-a231-7b88541b41d9.png'
        this.failImg = '1b92b94c-6cfe-4eb3-a231-7b88541b41d9.png'
      }
    },
    adapterButtonCtxes(data) {
      if (!Array.isArray(data)) return []
      let buttonData = data.map((b) => {
        return {
          cmd: b.type,
          targetUrl: b.mUrl,
          text: b.buttonDesc,
          style: b.style || 'normal'
        }
      })
      // 二次放号场景客户端needclose冲突处理：iOS 11.16.0版本以下在二次挑战认证页面只展示关闭按钮
      const appType = getCookie('t')
      const isNeedCloseConflictFix = this.from === 'zhzh_challenge_page' && appType === '16' && this.isVersionLowerThan11_16_0()
      if (isNeedCloseConflictFix) {
        buttonData = buttonData.filter(b => b.cmd === 'close')
      }
      if (isCheckApp) {
        buttonData = buttonData.reverse().map((b) => {
          if (b.text.indexOf('退出') > -1) {
            b.text = '退出'
          }
          return b
        })
      }
      return buttonData
    },
    doCommand(ctx) {
      lego.send({
        pagetype: 'ZZUP_REALAUTH_RESULT',
        actiontype: ctx.cmd,
        backup: {
          from: this.from,
          strategyid: this.strategyid,
          result: this.result
        }
      })
      if (ctx.cmd === 'close') {
        native.close()
      } else if (ctx.cmd === 'jump') {
        native.skipToUrl({
          targetUrl: ctx.targetUrl,
          needClose: '1'
        })
      } else if (ctx.cmd === 'audit') {
        console.log('cmd', ctx.cmd)
        native.skipToUrl({
          targetUrl: `https://app.zhuanzhuan.com/zz/redirect/faceauthcheckredirect?sourceCode=${this.from}`,
          needClose: '1'
        })
      } else if (ctx.cmd === 'reverify') {
        if (lower54 && !isHunterApp) {
          native.skipToUrl({
            targetUrl: `https://m.zhuanzhuan.com/platform/zzappsupport/#/realpersonauth/basicverify?from=${this.from}&strategyid=${this.strategyid}&reauth=1`,
            newPageTitle: '实人认证',
            needClose: '1'
          })
        } else {
          native.wrap('enterUnifiedUrl')({
            unifiedUrl: `${adapterSchema}://jump/core/realPersonAuth/jump?strategyid=${this.strategyid}&sourcecode=${this.from}&lastagreementno=${this.agreementNo}&authtype=${this.authtype}`,
            needClose: '1'
          })
        }
      }
    }
  },
  created() {
    native.setTitle({
      title: '实人认证'
    })

    getsdkcallbacktext({
      sourcecode: this.from,
      strategyid: this.strategyid,
      code: this.txCode,
      agreementNo: this.agreementNo,
      intermediate: this.isInter
    })
      .then((res) => {
        console.info(res)
        this.result = res.isPass
        this.resInfo = res.copywriting
        this.intermediate = res.intermediate
        this.buttonCtxes = res.retButtons
        if (this.result === 'true') {
          localStorage.removeItem('user_name')
          localStorage.removeItem('card_id')

          native.wrap('sendNotification')({
            name: 'ZZ_NOTIFICATION_REAL_CERTIFICATION_SUCCESS',
            args: JSON.stringify({ userId: getCookie('uid') })
          })
        }

        lego.send({
          pagetype: 'ZZUP_REALAUTH_RESULT',
          actiontype: 'PAGE_SHOW',
          backup: {
            from: this.from,
            strategyid: this.strategyid,
            txcode: this.txCode,
            result: this.result
          }
        })
      })
      .catch((err) => {
        console.error(err)
        toast({
          msg: err,
          style: '2'
        })
      })
    this.adapterOS()
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      const pageLock = query.lock || vm.$route.query.lock
      if (!pageLock && lower54 && !isHunterApp) {
        native.skipToUrl({
          targetUrl: location.href.replace(/\?(.*)/, '?lock=1&$1'),
          needClose: '1'
        })
      }
    })
  }
}
</script>

<style lang="less" scoped>
  @import './Result.less';
</style>
